import { Chains } from 'context/Chain'

const GENERIC_TRANSLATION = {
  unauthenticated: {
    faqview: {
      faq: {
        accordion: {
          content: {
            10: `A rede {{name}} é uma das mais promissoras infraestruturas para NFT atualmente com uma grande comunidade de desenvolvedores, empresas e organizações dedicados a fortalecer e amadurecer a tecnologia e suas aplicações.`,
          },
        },
      },
    },
  },
}

export default {
  POLYGON: GENERIC_TRANSLATION,
  ETHEREUM: GENERIC_TRANSLATION,
  MOONBEAM: {
    unauthenticated: {
      faqview: {
        faq: {
          accordion: {
            content: {
              10: `A {{name}} é uma parachain da rede Polkadot com foco em interoperabilidade e suporte a EVM. É a maior parachain em termos de volume e transações da Polkadot, por isso a escolhemos para lançar esta loja.`,
            },
          },
        },
      },
    },
  },
} satisfies {
  [chainId in Chains]: {
    unauthenticated: {
      faqview: {
        faq: {
          accordion: {
            content: {
              10: string
            }
          }
        }
      }
    }
  }
}
